export default "__VITE_ASSET__DnAYR0UH__"